import { cn } from '@/lib/utils';

const STEPS = [
  { number: 1, label: 'Upload' },
  { number: 2, label: 'Map columns' },
  { number: 3, label: 'Preview' },
  { number: 4, label: 'Import' },
] as const;

type ImportContactsStepIndicatorProps = {
  currentStep: number;
};

export const ImportContactsStepIndicator = ({ currentStep }: ImportContactsStepIndicatorProps) => (
  <div className="flex flex-wrap items-center gap-2">
    {STEPS.map((step, index) => {
      const state =
        step.number < currentStep ? 'done' : step.number === currentStep ? 'active' : 'pending';

      return (
        <div key={step.number} className="flex items-center gap-2">
          {index > 0 ? <span className="h-px w-8 bg-neutral-200" aria-hidden /> : null}
          <div className="flex items-center gap-2" data-state={state}>
            <span
              className={cn(
                'inline-flex size-7 shrink-0 items-center justify-center rounded-full text-[13px] font-semibold',
                state === 'active' && 'bg-primary-600 text-white',
                state === 'done' && 'bg-emerald-700 text-white',
                state === 'pending' && 'bg-neutral-100 text-neutral-600'
              )}
            >
              {step.number}
            </span>
            <span
              className={cn(
                'text-[13px] font-medium text-neutral-600',
                (state === 'active' || state === 'done') && 'font-semibold text-neutral-900'
              )}
            >
              {step.label}
            </span>
          </div>
        </div>
      );
    })}
  </div>
);
